const CODE = {
  ok: 0,
  notlogin: 10001,
  noprivilege: 10002
}

export default CODE
